// Characters that spreadsheet software (Excel, Numbers, Calc) interprets as formula prefixes.
// See https://owasp.org/www-community/attacks/CSV_Injection
const CSV_INJECTION_PREFIXES = ['=', '+', '-', '@', '\t', '\r', '🟰', '＝', '＋', '－', '＠'];

function _needsCsvInjectionSanitization(s: string): boolean {
  return CSV_INJECTION_PREFIXES.some((prefix) => s.startsWith(prefix));
}

function _formatCellForDelimiter(s: string, d: string): string {
  // CSV has much stricter requirements for what must be escaped, so we must do two separate checks.
  switch (d) {
    case '\t':
      return s.replace(/\t/g, ' ');
    case ',': {
      const shouldSanitizeCsvInjection = _needsCsvInjectionSanitization(s);
      if (shouldSanitizeCsvInjection) {
        s = `'${s}`;
      }
      // CSV injection-safe values are always quoted so spreadsheet software preserves the leading quote.
      if (shouldSanitizeCsvInjection || /[",\n\r]/.test(s)) {
        s = s.replace(/"/g, '""');
        return `"${s}"`;
      }

      return s;
    }
    default:
      return s;
  }
}

function _formatRow(row: Array<string>, delimiter: string): string {
  return row.map((cell) => _formatCellForDelimiter(cell, delimiter)).join(delimiter);
}

export function formatRows(rows: Array<Array<string>>, delimiter: string): string {
  let result = rows.map((row) => _formatRow(row, delimiter)).join('\n');
  result += '\n';
  return result;
}
